import { z } from "zod";

export const getVehicleByUuidRequestSchema = z.object({
  vehicleUuid: z.uuid(),
});

export type GetVehicleByUuidRequest = z.infer<
  typeof getVehicleByUuidRequestSchema
>;
